import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { ReactState } from '../Contexts'
import { LicenceValue } from '../Types/Types'
import { getLicenceValue } from '../API/Licence/LicenceAPI'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export const useLicenceValue = (key: string): Nullable<LicenceValue> => {
    const [licenceValue, setLicenceValue]: ReactState<Nullable<LicenceValue>> = useState<Nullable<LicenceValue>>()

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        getLicenceValue(key)
            .then((response: JSONResponse<LicenceValue>): void => {
                if (isMounted.current) {
                    setLicenceValue(response)
                }
            })
            .catch((): void => {
                if (isMounted.current) {
                    setLicenceValue(undefined)
                }
            })
    }, [key])

    return licenceValue
}
